import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import Expander from 'components/utils/Expander'
import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import useToggle from 'hooks/useToggle'

interface Props extends PropsWithChildren {
  openLabel: string
  closedLabel: string
  size?: 'caption' | 'small' | 'medium' | 'large'
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`

const FoldableContent = React.forwardRef<HTMLDivElement, Props>(
  ({ openLabel, closedLabel, children, size }: Props, ref) => {
    const [isOpen, onToggle] = useToggle()

    return (
      <Root>
        <SmallToggleButton
          onClick={onToggle}
          on={isOpen}
          size={size}
        >
          {isOpen ? openLabel : closedLabel}
        </SmallToggleButton>
        <Expander expanded={isOpen} ref={ref}>
          {children}
        </Expander>
      </Root>
    )
  },
)

export default FoldableContent
